import { Box } from '@mui/material';
import React from 'react';
import { RecurrenceEnum } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';
import { FormState } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/AddHypotheses/AgentHypothesisModal/AgentHypothesisModal';
import { HypothesisChoice } from './constants';
import AgentPayComponentHypothesisModalContent from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/PayComponent/AgentPayComponentHypothesisModalContent';
import { SimulationAgentData } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/helpers/types';
import {
    HistoricDataFilters,
    PreviousDataFilters,
} from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/components/ValueByDate/helpers/dataHelpers';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import { DateString } from 'routes/HumanResourcesModule/business/types';
import { AgentPayComponentHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/PayComponent/helpers/types';
import AgentIfseHypothesisModalContent from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/PayComponent/ifse/AgentIfseHypothesisModalContent';
import AgentDepartureHypothesisModal from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/Departure/AgentDepartureHypothesisModal/AgentDepartureHypothesisModal';
import GradeAdvancementHypothesisModalContent from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/GradeAdvancement/GradeAdvancementHypothesisModalContent';
import { FreeHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/helpers/types';

type Props = {
    selectedHypothesisType: string | null;
    ponctualPrimeHypothesis: AgentPayComponentHypothesis | undefined;
    freeHypothesisAffectingAgent: FreeHypothesis | undefined;
    agentData: SimulationAgentData;
    formState: FormState;
    setFormState: React.Dispatch<React.SetStateAction<FormState>>;
    recurrence: RecurrenceEnum;
    hrSimulation: HrSimulation;
    filters: HistoricDataFilters | PreviousDataFilters;
    onPonctualPrimesValuesByDatesChange: (
        newValuesByDates: Record<DateString, number>,
    ) => void;
};

export const HypothesisModalSelector = ({
    agentData,
    filters,
    hrSimulation,
    onPonctualPrimesValuesByDatesChange,
    ponctualPrimeHypothesis,
    freeHypothesisAffectingAgent,
    recurrence,
    selectedHypothesisType,
    formState,
    setFormState,
}: Props): React.ReactElement => (
    <>
        {selectedHypothesisType === HypothesisChoice.DEPARTURE && (
            <Box>
                <AgentDepartureHypothesisModal
                    hrSimulation={hrSimulation}
                    agentData={agentData}
                    recurrence={recurrence}
                    formState={formState}
                    setFormState={setFormState}
                />
            </Box>
        )}
        {selectedHypothesisType === HypothesisChoice.PRIME && (
            <AgentPayComponentHypothesisModalContent
                hrSimulation={hrSimulation}
                filters={filters}
                hypothesis={ponctualPrimeHypothesis}
                onValuesByDatesChange={onPonctualPrimesValuesByDatesChange}
                formState={formState}
                setFormState={setFormState}
            />
        )}
        {selectedHypothesisType === HypothesisChoice.IFSE && (
            <AgentIfseHypothesisModalContent
                hrSimulation={hrSimulation}
                agentData={agentData}
                formState={formState}
                setFormState={setFormState}
                freeHypothesisAffectingAgent={freeHypothesisAffectingAgent}
            />
        )}
        {selectedHypothesisType === HypothesisChoice.GRADE && (
            <GradeAdvancementHypothesisModalContent
                hrSimulation={hrSimulation}
                agentData={agentData}
                formState={formState}
                setFormState={setFormState}
                recurrence={recurrence}
            />
        )}
    </>
);
